export default __webpack_public_path__ + "static/team_new-b04ff953dc41df53b57df233ca151051.jpg";